define('OutSystems/ClientRuntime/modules/Database/Common/EntityModelInitializer',["require", "exports", "tslib", "../../../Logger", "../Metadata/EntityUpgradeStatus", "../Metadata/MetadataTableInfo", "./EntityModelUtils"], function (require, exports, tslib_1, Logger, EntityUpgradeStatus_1, MetadataTableInfo_1, EntityModelUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EntityModelInitializer = (function () {
        function EntityModelInitializer(entityInfos, serializer) {
            this.entityInfos = entityInfos;
            this.serializer = serializer;
        }
        EntityModelInitializer.prototype.isNeeded = function (transaction) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var existsMetadataTable, moduleKey, storedMetadata, _loop_1, _i, _a, entity, state_1, _loop_2, this_1, _b, storedMetadata_1, storedEntity, state_2;
                return tslib_1.__generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!this.hasEntityInfos()) return [3, 3];
                            return [4, transaction.existsTable(MetadataTableInfo_1.default)];
                        case 1:
                            existsMetadataTable = _c.sent();
                            if (!existsMetadataTable) {
                                return [2, true];
                            }
                            moduleKey = EntityModelUtils.getFirstItem(this.entityInfos).moduleKey;
                            return [4, EntityModelUtils.loadStoredMetadata(transaction, moduleKey)];
                        case 2:
                            storedMetadata = _c.sent();
                            _loop_1 = function (entity) {
                                var entityStored = EntityModelUtils.getFirstItem(storedMetadata.filter(function (m) { return m.KEY === entity.key; }));
                                if (!entityStored ||
                                    entityStored.HASH !== entity.hash ||
                                    entityStored.UPGRADESTATUS !== EntityUpgradeStatus_1.default.Unchanged ||
                                    entityStored.TABLENAME !== entity.tableName) {
                                    return { value: true };
                                }
                            };
                            for (_i = 0, _a = this.entityInfos; _i < _a.length; _i++) {
                                entity = _a[_i];
                                state_1 = _loop_1(entity);
                                if (typeof state_1 === "object")
                                    return [2, state_1.value];
                            }
                            _loop_2 = function (storedEntity) {
                                if (!this_1.entityInfos.some(function (m) { return m.key === storedEntity.KEY; })) {
                                    return { value: true };
                                }
                            };
                            this_1 = this;
                            for (_b = 0, storedMetadata_1 = storedMetadata; _b < storedMetadata_1.length; _b++) {
                                storedEntity = storedMetadata_1[_b];
                                state_2 = _loop_2(storedEntity);
                                if (typeof state_2 === "object")
                                    return [2, state_2.value];
                            }
                            _c.label = 3;
                        case 3: return [2, false];
                    }
                });
            });
        };
        EntityModelInitializer.prototype.run = function (transaction) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var moduleKey, storedMetadata, _loop_3, this_2, _i, _a, entityInfo;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.hasEntityInfos()) {
                                return [2];
                            }
                            moduleKey = EntityModelUtils.getFirstItem(this.entityInfos).moduleKey;
                            this.trace("Running initializer for entities of module '".concat(moduleKey, "'."));
                            return [4, EntityModelUtils.recoverBackupTables(transaction, this.entityInfos, moduleKey)];
                        case 1:
                            _b.sent();
                            if (!(this.entityInfos.length > 0)) return [3, 3];
                            return [4, EntityModelUtils.dropInconsistentTables(transaction, this.entityInfos, moduleKey)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3: return [4, EntityModelUtils.backupDeletedTables(transaction, this.entityInfos, moduleKey)];
                        case 4:
                            _b.sent();
                            return [4, EntityModelUtils.loadStoredMetadata(transaction, moduleKey)];
                        case 5:
                            storedMetadata = _b.sent();
                            _loop_3 = function (entityInfo) {
                                var tableInfo, tableMetadata;
                                return tslib_1.__generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            tableInfo = entityInfo;
                                            tableMetadata = EntityModelUtils.getFirstItem(storedMetadata.filter(function (m) { return m.KEY === tableInfo.key; }));
                                            return [4, EntityModelUtils.createOrUpgradeTable(transaction, tableInfo, tableMetadata, this_2.serializer)];
                                        case 1:
                                            _c.sent();
                                            return [2];
                                    }
                                });
                            };
                            this_2 = this;
                            _i = 0, _a = this.entityInfos;
                            _b.label = 6;
                        case 6:
                            if (!(_i < _a.length)) return [3, 9];
                            entityInfo = _a[_i];
                            return [5, _loop_3(entityInfo)];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            _i++;
                            return [3, 6];
                        case 9:
                            this.trace("Initializer for entities of module '".concat(moduleKey, "' ran successfully."));
                            return [2];
                    }
                });
            });
        };
        EntityModelInitializer.prototype.cleanup = function (transaction) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var moduleKey;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.hasEntityInfos()) {
                                return [2];
                            }
                            moduleKey = EntityModelUtils.getFirstItem(this.entityInfos).moduleKey;
                            this.trace("Running initializer cleanup for entities of module '".concat(moduleKey, "'."));
                            return [4, EntityModelUtils.dropBackupTables(transaction, moduleKey)];
                        case 1:
                            _a.sent();
                            this.trace("Initializer cleanup for entities of module '".concat(moduleKey, "' ran successfully."));
                            return [2];
                    }
                });
            });
        };
        EntityModelInitializer.prototype.hasEntityInfos = function () {
            return this.entityInfos && this.entityInfos.length > 0;
        };
        EntityModelInitializer.prototype.trace = function (message) {
            Logger.trace(this, message);
        };
        return EntityModelInitializer;
    }());
    exports.default = EntityModelInitializer;
});
//# sourceMappingURL=EntityModelInitializer.js.map;
